import { render, staticRenderFns } from "./OverviewSideNav.vue?vue&type=template&id=6c53768f&"
import script from "./OverviewSideNav.vue?vue&type=script&lang=js&"
export * from "./OverviewSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports